import { render, staticRenderFns } from "./moon.vue?vue&type=template&id=38e4de91&scoped=true&"
import script from "./moon.vue?vue&type=script&lang=js&"
export * from "./moon.vue?vue&type=script&lang=js&"
import style0 from "./moon.vue?vue&type=style&index=0&id=38e4de91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4de91",
  null
  
)

export default component.exports